/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import merge from 'lodash/merge';
import { createSelector } from 'reselect';

import {
  GET_AVAILABLE_KPIS,
  GET_AVAILABLE_KPIS_FAILURE,
  GET_AVAILABLE_KPIS_SUCCESS,
  GET_KPI_METADATA_SUCCESS,
  GET_KPI_METADATA_FAILURE,
  CLEAR_AVAILABLE_KPIS,
} from 'kpiActionCreators';

export const catalogFunctionsReducer = (
  state = { data: {}, updatingData: false, fetchingData: false },
  action
) => {
  switch (action.type) {
    case GET_AVAILABLE_KPIS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
        data: action.payload,
      };

    case CLEAR_AVAILABLE_KPIS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: {},
      };
    case GET_AVAILABLE_KPIS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: action.payload,
      };

    case GET_AVAILABLE_KPIS_FAILURE:
    case GET_KPI_METADATA_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_KPI_METADATA_SUCCESS:
      return merge(
        {},
        {
          data: {
            [action.payload.name]: action.payload,
          },
        },
        state,
        {
          fetchingData: false,
          fetchDataError: null,
        }
      );

    default:
      return state;
  }
};

const selectKPIs = state => get(state, 'catalogFunctions.data', {});
// selectors
export const getCatalogFunctions = createSelector([selectKPIs], selectedKPIs =>
  Object.values(selectedKPIs)
);
